import React, { Component, useEffect, useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import getList from "../Redux/actions/CommonServices";
import Message from "../Components/message";
import { useCookies } from 'react-cookie';
import { v4 as uuidv4 } from 'uuid';
import ReCAPTCHA from "react-google-recaptcha";

import {
    CustomProvider,
    Input,
    DatePicker,
    SelectPicker,
    Form, 
    Schema
} from 'rsuite';
import * as locales from 'rsuite/locales';

import { transLabel, getBase64 } from '../translations/util';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { getTextFieldUtilityClass, IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import AddCase from '../Redux/actions/caseActions';
import { loginChk } from '../Redux/actions/userActions';

const Textarea = React.forwardRef((props, ref) => <Input style={{ width: "100%" }} {...props} as="textarea" ref={ref} />);

const { ArrayType, StringType, DateType, NumberType, ObjectType } = Schema.Types;
let model = [];

const data = Object.keys(locales).map(key => ({
    key,
    value: locales[key]
}));

const TextField = React.forwardRef((props, ref) => {
    const { name, label, accepter, locale, ...rest } = props;
    if(name == "fechaInfraccion" || name == "fechaConocimientoInfraccion"){    
        let dateFormat = (locale.key == "esES") ? "dd/MM/yyyy" : "yyyy-MM-dd";

        return (
            <Form.Group controlId={`${name}-4`} ref={ref}>
                <Form.ControlLabel>{label} {model?.$spec[name]?.required ? <span style={{ FontWeight: "bold", color: "red" }}>*</span> : ""}</Form.ControlLabel>
                <Form.Control name={name} accepter={accepter} {...rest} isoWeek format={dateFormat}/>
            </Form.Group>
        );
    }
    
    return (
        <Form.Group controlId={`${name}-4`} ref={ref}>
            <Form.ControlLabel>{label} {model?.$spec[name]?.required ? <span style={{ FontWeight: "bold", color: "red" }}>*</span> : ""}</Form.ControlLabel>
            <Form.Control name={name} accepter={accepter} {...rest}/>
        </Form.Group>
    );
});

const NewCase = () => {
    const formRef = React.useRef();
    const [formError, setFormError] = React.useState({});
    const msgRef = React.useRef();
    const [formValue, setFormValue] = React.useState({});
    const translations = useSelector(state => state.translationReducer);
    const [translation, setTranslation] = useState([]);
    const [paises, setPaises] = useState([]);
    const [vinculaciones, setVinculaciones] = useState([]);
    const [entidades, setEntidades] = useState([]);
    const [empresaGrupo, setEmpresaGrupo] = useState([]);
    const [identificacion, setIdentificacion] = useState([]);
    const [departamento, setDepartamento] = useState([]);
    const navigate = useNavigate();
    const [cookies, setCookie] = useCookies(['languaje']);
    let lan = (cookies.languaje == null) ? "ES" : cookies.languaje;
    let requieredText = (lan == "ES") ? ". Requerido" : ". Required";
    const dispatch = useDispatch();
    let [files, setFiles] = useState([]);
    const forceUpdate = React.useReducer(bool => !bool)[1];
    const [captcha, setCaptcha] = useState('');
    const chkRef = React.useRef();
    const [config, setConfig] = useState([]);

    const [showPassword, setShowPassword] = useState(false);
    const [showRPassword, setShowRPassword] = useState(false);

    const [validPassword, setCheckPassword] = useState(false);

    let local = (lan == "ES") ? "esES" : "enGB";
    const locale = data.find(item => item.key === local); 

    const handleFileClick = event => {
        document.getElementById("hiddenFileInput").click();
    };

    const handleFileChange = e => {
        let theFile = e.target.files[0];
        let fileExt = theFile.name.split('.').pop();
        let uploadLockFileExt = config.filter(c => c.nombre == "UPLOAD_LOCK_FILE_EXTENSION")[0].value;

        if (theFile.length < 1) {
            return;
        }

        if (uploadLockFileExt.toLowerCase().indexOf(fileExt.toLowerCase()) != -1) {
            if (lan == "ES") {
                alert("Lo siento, este tipo de archivo no está permitido por razones de seguridad");
            } else {
                alert("Sorry, this file type is not allowed for security reasons");
            }
            return;
        }

        getBase64(theFile)
            .then(result => {
                let file = {};
                file.idx = uuidv4();
                file.idCasoDocumentacion = 0;
                file.idCaso = 0;
                file.nombreArchivo = theFile.name;
                file.extensionArchivo = theFile.name.split(".")[1];
                file.contenidoArchivo = result;
                file.esPrivado = 0;
                if (files.length == 0) {
                    files = new Array();
                }

                files.push(file);
                setFiles(files);
                forceUpdate();
            })
            .catch(err => {
                //console.log(err);
            });
    };

    let model1 = Schema.Model({
        descCaso: StringType().isRequired(transLabel("case.descCaso") + requieredText),
        fechaConocimientoInfraccion: DateType().isRequired(transLabel("NewCase.fechaConocimientoInfraccion") + requieredText),
        fechaInfraccion: DateType().isRequired(transLabel("NewCase.date") + requieredText),
        modoConocimientoInfraccion: StringType().isRequired(transLabel("NewCase.wayofknowing") + requieredText),
        //idPais: NumberType().isRequired(transLabel("NewCase.Country")+requieredText),
        //idEmpresaGrupo: NumberType().isRequired(transLabel("NewCase.Groupcompany")+requieredText),
        //Departamento: StringType().isRequired(transLabel("NewCase.Department")+requieredText),
        nombreInfractor: StringType().isRequired(transLabel("NewCase.Id") + requieredText),
        entidadJuridica: StringType().isRequired(transLabel("NewCase.Entity") + requieredText),
    });

    const model2 = Schema.Model({
        //Nombre: StringType().isRequired(transLabel("NewCase.Name") + requieredText),
        //Apellido1: StringType().isRequired(transLabel("NewCase.LastName")+requieredText),
        //Apellido2: StringType().isRequired(transLabel("NewCase.secondsurname")+requieredText),
        vinculacion: StringType().isRequired(transLabel("NewCase.vinculacion") + requieredText),
        idEmpresa: NumberType().isRequired(transLabel("NewCase.Groupcompany") + requieredText),
        //telefono: StringType().isRequired(transLabel("NewCase.phone")+requieredText),
        //eMail: StringType().isEmail(transLabel("NewCase.validEmail")).isRequired(transLabel("NewCase.eMail") + requieredText),
        password: StringType().isRequired(transLabel("NewCase.password") + requieredText),
        rpassword: StringType().addRule((value, data) => {
            //console.log(data);

            if (value !== data.password) {
                return false;
            }

            return true;
        }, 'The two passwords do not match').isRequired(transLabel("NewCase.rpassword") + requieredText),
    });

    model = Schema.Model.combine(model1, model2);

    const toPage = (page) => {
        navigate(page);
    }

    const checkPassword = (event) => {
        var value = event;
        
        var check_longitud = false;
        var check_obligatorio = false;

        const longitudMinima = document.querySelector('#longitudMinima');
        const obligatorio = document.querySelector('#obligatorio');

        if (value.length == 0) {
            check_longitud = false;
            check_obligatorio = false;

            longitudMinima.className = 'password-longitud-minima';
            obligatorio.className = 'password-obligatorio';
        }
        else {
            if (value.length >= 8) {
                check_longitud = true;
                longitudMinima.className = 'valid-password-longitud-minima';
            }
            else {
                check_longitud = false;
                longitudMinima.className = 'error-password-longitud-minima';
            }

            if (value.match(/^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])/)) {
                check_obligatorio = true;
                obligatorio.className = 'valid-password-obligatorio';
            }
            else {
                check_obligatorio = false;
                obligatorio.className = 'error-password-obligatorio';
            }
        }

        if (check_longitud === false || check_obligatorio === false)
            setCheckPassword(false);
        else
            setCheckPassword(true);
    }

    const MostrarNuevaClave = () => {
        var elementInput = document.getElementById("clave");
        var elementIcon = document.getElementById("spanMostrar");

        if (document.getElementsByClassName('.clave-muestra').css('display') == 'none') {
            elementInput.type = "text";
            document.getElementsByClassName(".clave-muestra").show();
            document.getElementsByClassName(".clave-oculta").hide();
        }
        else {
            elementInput.type = "password";
            document.getElementsByClassName(".clave-muestra").hide();
            document.getElementsByClassName(".clave-oculta").show();
        }
    }

    const MostrarRepetirClave = () => {
        var elementInput = document.getElementById("claveRep");
        var elementIcon = document.getElementById("spanMostrar");

        if (document.getElementsByClassName('.claveRep-muestra').css('display') == 'none') {
            elementInput.type = "text";
            document.getElementsByClassName(".claveRep-muestra").show();
            document.getElementsByClassName(".claveRep-oculta").hide();
        }
        else {
            elementInput.type = "password";
            document.getElementsByClassName(".claveRep-muestra").hide();
            document.getElementsByClassName(".claveRep-oculta").show();
        }
    }

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleClickShowRPassword = () => setShowRPassword((show) => !show);

    const handleSubmit = async () => {
        let caso = (({ descCaso,
            fechaConocimientoInfraccion,
            fechaInfraccion,
            modoConocimientoInfraccion,
            idPais,
            idEmpresaGrupo,
            Departamento,
            nombreInfractor,
            entidadJuridica }) =>
        ({
            descCaso,
            fechaConocimientoInfraccion,
            fechaInfraccion,
            modoConocimientoInfraccion,
            idPais,
            idEmpresaGrupo,
            Departamento,
            nombreInfractor,
            entidadJuridica
        }))(formValue);

        let usuario = (({ Nombre,
            Apellido1,
            Apellido2,
            vinculacion,
            idEmpresa,
            telefono,
            eMail,
            password }) =>
        ({
            Nombre,
            Apellido1,
            Apellido2,
            vinculacion,
            idEmpresa,
            telefono,
            eMail,
            password
        }))(formValue);

        let msg = "";

        var today = new Date();

        if (caso.fechaConocimientoInfraccion > today) {
            if (lan == "ES") {
                msg = "La fecha del conocimiento debe ser menor o igual a la fecha actual";
            } else {
                msg = "The knowledge date must be less than or equal to the current date";
            }
            msgRef.current.show(msg, transLabel("case.title"), 'error');
            return;
        }

        if (caso.fechaConocimientoInfraccion < caso.fechaInfraccion) {
            if (lan == "ES") {
                msg = "La fecha del conocimiento debe ser mayor o igual a la fecha del suceso";
            } else {
                msg = "The date of knowledge must be greater than or equal to the date of the event";
            }
            msgRef.current.show(msg, transLabel("case.title"), 'error');
            return;
        }

        if (usuario.vinculacion == "Empleado/a, directivo/a o administrador/a" && (usuario.idEmpresa == null || usuario.idEmpresa == 0)) {
            msg = transLabel("NewCase.Groupcompany") + requieredText + "<br/>";
        }

        caso.tokenIdentificador = uuidv4();

        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        var email = usuario.eMail;

        if (email == null) {
            email = caso.tokenIdentificador;
            usuario.eMail = email;
        }
        else if (!email.match(validRegex)) {
            alert(transLabel("NewCase.validEmail"));
            return 0;
        }

        let loginResult = await loginChk({
            "usuario": email,
            "password": usuario.password
        });

        if (loginResult.exists && !loginResult.valid) {
            if (lan == "ES") {
                alert("La contraseña introducida no coincide con la registrada asociada a su eMail");
            } else {
                alert("The password entered does not match the one registered associated with your eMail");
            }
            return;
        }

        if (!formRef.current.check() || msg != "") {
            //console.log("formError",formError);
            for (const [key, value] of Object.entries(formError)) {
                msg += value + "<br/>"
            }
            if (msg != "") {
                msgRef.current.show(msg, transLabel("case.title"), 'error');
            }
            return;
        }

        //console.log('FormValue', caso);
        //caso.tokenIdentificador = uuidv4();

        let json = {
            caso,
            usuario,
            casoDocumentos: files,
            lan
        };

        //console.log("json", json);
        dispatch(AddCase(json, function (response) {
            if (response) {
                toPage("/code-tracking");
            }
        }));
    };

    useEffect(() => {
        getList("Paises/Get?lan=" + lan, null, function (response) {
            //console.log("Paises", response);
            response = response.sort(function (a, b) {
                var textA = a.tituloPais.toUpperCase();
                var textB = b.tituloPais.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            setPaises(response);
        });
    }, [lan]);

    useEffect(() => {
        setTranslation(translations);
        let lan = (cookies.languaje == null) ? "ES" : cookies.languaje;
        requieredText = (lan == "ES") ? ". Requerido" : ". Required";
    }, [translations]);

    useEffect(() => {
        getList("Paises/Get?lan=" + lan, null, function (response) {
            //console.log("Paises", response);
            response = response.sort(function (a, b) {
                var textA = a.tituloPais.toUpperCase();
                var textB = b.tituloPais.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            setPaises(response);
        });

        getList("Vinculaciones/Get", null, function (response) {
            //console.log("Vinculaciones", response);
            response = response.sort(function (a, b) {
                var textA = a.tituloVinculacion.toUpperCase();
                var textB = b.tituloVinculacion.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            setVinculaciones(response);
        });

        getList("Entidad/Get", null, function (response) {
            //console.log("Entidades", response);
            setEntidades(response);
        });

        getList("EmpresaGrupo/Get", null, function (response) {
            //console.log("EmpresaGrupo", response);
            let idx = 0;

            response = response.sort(function (a, b) {
                var textA = a.tituloEmpresa.toUpperCase();
                var textB = b.tituloEmpresa.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

            response.map((element) => {
                element.idx = idx + 1;
                if (element.tituloEmpresa.indexOf("OTRA COM") != -1) {
                    element.idx = -100;
                }
                idx++;
            });

            response = response.sort(function (a, b) {
                var textA = a.idx;
                var textB = b.idx;
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });


            setEmpresaGrupo(response);
        });

        getList("Identificacion/Get", null, function (response) {
            //console.log("Identificacion", response);
            setIdentificacion(response);
        });

        getList("Departamento/Get", null, function (response) {
            //console.log("Departamento", response);
            setDepartamento(response);
        });
        getList("Config/Get", null, function (response) {
            setConfig(response);
        });
    }, []);

    function onChangeCaptcha(value) {
        setCaptcha(value)
    }

    const { t } = useTranslation();

    return (
        <Form model={model} ref={formRef} onChange={setFormValue} onCheck={setFormError} formValue={formValue} autoComplete="off" autofill="off">
            <Header />
            <div id="banner-inboard" className="container-fluid">
                <div className="d-flex align-items-center ps-4">
                    <img className="float-start" src="assets/img/capital-letter-ethics-channel-ayesa.png" />
                    <h1 className="ps-3 text-white">{transLabel("case.title2")}</h1>
                </div>
            </div>
            <nav className="ps-3" aria-label="breadcrumb">
                <ol className="breadcrumb py-2">
                    <li className="breadcrumb-item"><a href="#" onClick={(e) => { toPage("/"); }}>{transLabel("NewCase.title")}</a></li>
                    <li className="breadcrumb-item active" aria-current="page">{transLabel("case.title2")}</li>
                </ol>
            </nav>
            <div className="container">
                <div className="row mt-5">
                    <div className="icon-clear col-md-1 position-relative">
                        <img className="position-absolute end-0" src="assets/img/icon-info-event.png" />
                    </div>
                    <div className="col-md-6 pt-2">
                        <h2 style={{ fontWeight: "600" }}>{transLabel("case.title")}</h2>
                        <p>{transLabel("NewCase.textoinfo1")}</p>
                    </div>
                </div>
                <div className="row offset-md-1 mt-2">
                    <div className="col-md-7">
                        <h4>{transLabel("case.descCaso1")}</h4>
                        <div className="mb-3">
                            <TextField name="descCaso" label={transLabel("case.descCaso")} placeholder={transLabel("NewCase.descCaso")} rows="10" accepter={Textarea} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <h4>{transLabel("NewCase.title3")}</h4>
                        <div className="input-group mb-3">
                            <TextField
                                accepter={DatePicker}
                                name="fechaInfraccion" 
                                label={transLabel("NewCase.date")}
                                placeholder={transLabel("NewCase.selectdate")}
                                errorMessage={formError.fechaInfraccion}
                                locale={locale}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <TextField
                                accepter={DatePicker}
                                name="fechaConocimientoInfraccion"
                                label={transLabel("NewCase.knowledgedate")}
                                placeholder={transLabel("NewCase.selectdate")}
                                errorMessage={formError.fechaConocimientoInfraccion}
                                locale={locale}
                            />
                        </div>
                        <div className="mb-3">
                            <TextField name="modoConocimientoInfraccion" label={transLabel("NewCase.wayofknowing")} placeholder={transLabel("NewCase.knowing")} rows="3" accepter={Textarea} />
                        </div>
                    </div>
                </div>
                <div className="row offset-md-1 mt-2">
                    <div className="">
                        <button type="button" onClick={handleFileClick} className="btn btn-secondary">{transLabel("NewCase.attachfile")}<span className="ms-3" style={{ fontFamily: "Material Icons" }}>attach_file</span></button>
                        <input
                            type="file"
                            id="hiddenFileInput"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                            value=""
                        />
                    </div>
                </div>
                <div className="row offset-md-1 mt-2">
                    <div className="col">
                        {files.length > 0 && files.map((element) =>
                            <button key={element.idx} type="button" className="btn btn-light">{element.nombreArchivo}<span className="ms-3" style={{ fontFamily: "Material Icons" }}
                                onClick={(e) => {
                                    const arrayFiles = files.filter((file, index) => element.idx !== file.idx);
                                    setFiles(arrayFiles);
                                    forceUpdate();
                                }}
                            >close</span></button>
                        )}

                    </div>
                </div>
                <div className="row offset-md-1 mt-5">
                    <p style={{ color: 'red' }}>{transLabel("NewCase.asterisco")}</p>
                </div>
                <div className="row offset-md-1 mt-5">
                    <h4 className="pb-1">{transLabel("NewCase.Locationofthefacts")}</h4>
                    <div className="col-md-6 col-lg-4">
                        <div className="mb-3">
                            <TextField
                                name="idPais"
                                label={transLabel("NewCase.Country")}
                                accepter={SelectPicker}
                                error={formError.idPais}
                                style={{ display: 'inline-block', width: 200 }}
                                data={paises}
                                placeholder={(lan == "EN") ? "Type to search..." : "Escribe para buscar..."}
                                labelKey="tituloPais"
                                valueKey="idPais"
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="mb-3">
                            <TextField
                                name="idEmpresaGrupo"
                                label={transLabel("NewCase.Groupcompany")}
                                accepter={SelectPicker}
                                error={formError.idEmpresaGrupo}
                                style={{ display: 'inline-block', width: 200 }}
                                data={empresaGrupo}
                                placeholder={(lan == "EN") ? "Type to search..." : "Escribe para buscar..."}
                                labelKey="tituloEmpresa"
                                valueKey="id"
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="mb-3">

                            <TextField name="Departamento" label={transLabel("NewCase.Department")} placeholder={(lan == "EN") ? "Type to search..." : "Escribe para buscar..."} />

                        </div>
                    </div>
                </div>

                <div className="row offset-md-1 mt-5">
                    <h4 className="pb-1">{transLabel("NewCase.Identification")}</h4>
                    <div className="col-md-6 col-lg-4">
                        <div className="mb-3">

                            <TextField name="nombreInfractor" label={transLabel("NewCase.Id")} placeholder={(lan == "EN") ? "Type to search..." : "Escribe para buscar..."} />

                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="mb-3">
                            <TextField
                                name="entidadJuridica"
                                label={transLabel("NewCase.Entity")}
                                accepter={SelectPicker}
                                error={formError.entidadJuridica}
                                style={{ display: 'inline-block', width: 200 }}
                                data={vinculaciones.filter(c => c.tipoVinculacion == "INFRACTOR")}
                                placeholder={(lan == "EN") ? "Type to search..." : "Escribe para buscar..."}
                                labelKey="tituloVinculacion"
                                valueKey="tituloVinculacion"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid py-5 my-5" style={{ backgroundColor: "#F3F3F3" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-1 position-relative">
                            <img className="icon-clear position-absolute end-0" src="assets/img/icon-user.png" />
                        </div>
                        <div className="col-md-7 pt-2">
                            <h2 style={{ FontWeight: "600" }}>{transLabel("NewCase.Contactinformation")}</h2>
                            <p>{transLabel("NewCase.textoinfo2")}</p>
                        </div>
                    </div>
                    {/* <div className="row offset-md-1">
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault"/>
                                <label className="form-check-label" >Activar esta opción si desea mantener el anonimato</label>
                            </div>
                        </div> */}

                    <div className="row offset-md-1 mt-5">
                        <h4 className="pb-1">{transLabel("NewCase.Personalinformation")}</h4>
                        <div className="col-md-6 col-lg-4">
                            <div className="mb-3">
                                <TextField
                                    name="Nombre"
                                    label={transLabel("NewCase.Name")}
                                    error={formError.Nombre}
                                />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="mb-3">
                                <TextField
                                    name="Apellido1"
                                    label={transLabel("NewCase.LastName")}
                                    error={formError.Apellido1}
                                />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="mb-3">
                                <TextField
                                    name="Apellido2"
                                    label={transLabel("NewCase.secondsurname")}
                                    error={formError.Apellido2}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row offset-md-1 mt-3">
                        <div className="col-md-6 col-lg-4">
                            <div className="mb-3">
                                <TextField
                                    name="vinculacion"
                                    label={transLabel("NewCase.vinculacion")}
                                    accepter={SelectPicker}
                                    error={formError.vinculacion}
                                    style={{ display: 'inline-block', width: 200 }}
                                    data={vinculaciones.filter(c => c.tipoVinculacion == "CONTACTO")}
                                    placeholder={(lan == "EN") ? "Type to search..." : "Escribe para buscar..."}
                                    labelKey="tituloVinculacion"
                                    valueKey="tituloVinculacion"
                                />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="mb-3">
                                <TextField
                                    name="idEmpresa"
                                    label={transLabel("NewCase.Groupcompany")}
                                    accepter={SelectPicker}
                                    error={formError.idEmpresa}
                                    style={{ display: 'inline-block', width: 200 }}
                                    data={empresaGrupo}
                                    placeholder={(lan == "EN") ? "Type to search..." : "Escribe para buscar..."}
                                    labelKey="tituloEmpresa"
                                    valueKey="id"
                                />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="mb-3">
                                <TextField
                                    name="telefono"
                                    label={transLabel("NewCase.phone")}
                                    error={formError.telefono}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row offset-md-1 mt-3 mb-5">
                        <div className="col-md-6 col-lg-4">
                            <TextField
                                name="eMail"
                                label={transLabel("NewCase.eMail")}
                                error={formError.eMail}
                                autofill="off"
                            />
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="mb-3">
                                <div className="row">
                                    <div className="col-md-11">
                                        <TextField
                                            id="clave"
                                            name="password"
                                            label={transLabel("NewCase.password")}
                                            error={formError.password}
                                            type={showPassword ? 'text' : 'password'}
                                            autoComplete="new-password"
                                            autofill="off"
                                            onChange={(e) => checkPassword(e)}
                                        />
                                    </div>
                                    <div className="col-md-1 btn-nc-password">
                                        {
                                            showPassword ?
                                                <i id="togglePassword" className="bi bi-eye-slash" onClick={handleClickShowPassword}></i>
                                                :
                                                <i id="togglePassword" className="bi bi-eye" onClick={handleClickShowPassword}></i>
                                        }
                                    </div>
                                </div>


                                <br />
                                <div id="longitudMinima" className='password-longitud-minima'>
                                    {transLabel("NewCase.Oglibatory8Characters")}.
                                </div>
                                <div id="obligatorio" className='password-obligatorio'>
                                    {transLabel("NewCase.ObligatoryTypeCharacters")}.
                                </div>
                                <hr />
                                <p>
                                    {transLabel("NewCase.readTxtPwd")}
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="mb-3">
                                <div className="row">
                                    <div className="col-md-11">
                                        <TextField
                                            name="rpassword"
                                            label={transLabel("NewCase.rpassword")}
                                            error={formError.rpassword}
                                            type={showRPassword ? 'text' : 'password'}
                                            autoComplete="off"
                                            autofill="off"
                                        />
                                    </div>
                                    <div className="col-md-1 btn-nc-password">
                                        {
                                            showRPassword ?
                                                <i id="toggleRPassword" className="bi bi-eye-slash" onClick={handleClickShowRPassword}></i>
                                                :
                                                <i id="toggleRPassword" className="bi bi-eye" onClick={handleClickShowRPassword}></i>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-center mb-5">
                <ReCAPTCHA sitekey="6Lez4lYmAAAAAErtwE03hEQR3b1s9py8INpFcTkh" onChange={onChangeCaptcha} />
            </div>
            <div className="d-flex justify-content-center mb-5">
                <div className="form-check form-check-div">
                    <input className="form-check-input" type="checkbox" onClick={(e) => forceUpdate()} ref={chkRef} value="" id="invalidCheck" required />
                    <label className="form-check-label" dangerouslySetInnerHTML={{ __html: transLabel("NewCase.heleido") }}></label>
                    {
                        (lan == "ES") ?
                            <div className="invalid-feedback">Es necesario aceptar <a href="https://www.ayesa.com/politica-de-privacidad" target="_blank">la política de privacidad</a></div>
                            :
                            <div className="invalid-feedback">It is necessary to accept <a href="https://www.ayesa.com/politica-de-privacidad" target="_blank">the privacy policy</a></div>
                    }
                </div>
            </div>

            <div className="d-flex justify-content-center mb-5">
                <button disabled={captcha === '' || captcha === null || !chkRef.current.checked || validPassword === false}
                    onClick={handleSubmit} type="button" className="btn btn-primary">{transLabel("NewCase.btnEnviarComunicacion")} <span className="ms-3" style={{ fontFamily: "Material Icons" }}>arrow_forward_ios</span></button>
            </div>

            <Footer />
            <Message ref={msgRef}></Message>
        </Form>
    );
}

export default NewCase;